module.exports = require('./readable').PassThrough



// WEBPACK FOOTER //
// webpack:///node_modules/readable-stream/passthrough.js